import * as THREE from 'three';
import * as FBXLoader from 'three-fbxloader-offical';
import * as OrbitControls from 'three-orbitcontrols';


export default class Model {

	static createScene () {

		if (Model.scene) {
			while(Model.scene.children.length > 0){
				Model.scene.remove(Model.scene.children[0]);
			}
		}

		Model.raycaster = new THREE.Raycaster();
		Model.mouse = new THREE.Vector2();

		Model.camera = new THREE.PerspectiveCamera(45, window.innerWidth / window.innerHeight, 1, 2000);
		Model.camera.position.set(-500, 500, 500);

		let controls = new OrbitControls(Model.camera);
		controls.enablePan = false;
		controls.enableZoom = false;
		controls.update();

		Model.scene = new THREE.Scene();
		Model.scene.background = new THREE.Color( 0xffffff );

		let light = new THREE.HemisphereLight( 0xffffff, 0x444444 );
		light.position.set( -500, 500, 500 );
		Model.scene.add( light );

		Model.renderer = new THREE.WebGLRenderer( { antialias: false } );
		Model.renderer.setPixelRatio( window.devicePixelRatio );
		Model.renderer.setSize(1920, 1080);
		Model.renderer.shadowMap.enabled = true;

		window.addEventListener( 'mousedown', Model.onMouseClick, false );
	}

	static onMouseClick( event ) {

		Model.mouse.x = ( event.clientX / Model.renderer.domElement.getBoundingClientRect().width ) * 2 - 1;
		Model.mouse.y = - ( event.clientY / Model.renderer.domElement.getBoundingClientRect().height ) * 2 + 1;

		Model.raycaster.setFromCamera( Model.mouse, Model.camera );

		let intersects = Model.raycaster.intersectObjects( Model.scene.children );

		for (let i = 0; i < intersects.length; i++) {
			if (intersects[i].object.name !== 'engine' && intersects[i].object.name !== 'F') {
				Model.onClickCallback({
					name: intersects[i].object.name,
					position: Model.toScreenPosition(intersects[i].object, Model.camera)
				});

				return;
			}
		}

		Model.onClickCallback(null);
	}

	static toScreenPosition(obj, camera)
	{
		var vector = new THREE.Vector3();

		var widthHalf = 0.5 * Model.renderer.context.canvas.width;
		var heightHalf = 0.5 * Model.renderer.context.canvas.height;

		obj.updateMatrixWorld();
		vector.setFromMatrixPosition(obj.matrixWorld);
		vector.project(camera);

		vector.x = ( vector.x * widthHalf ) + widthHalf;
		vector.y = - ( vector.y * heightHalf ) + heightHalf;

		return {
			x: vector.x,
			y: vector.y
		};

	}

	static loadModels () {
		let loader = new FBXLoader();

		loader.manager.onLoad = () => {

			loader.manager.onLoad = () => {
				Model.finishedLoading();
			};

			loader.load('/model/x.fbx', ( group ) => {

				let hotspot = group.children[0].clone();
				hotspot.material[0].color = new THREE.Color('#293279');
				hotspot.material[1].color = new THREE.Color('#191918');
				hotspot.material[2].color = new THREE.Color('#7ecad6');
				hotspot.material[3].color = new THREE.Color('#747678');
				hotspot.material[4].color = new THREE.Color('#1d8acb');

				Model.A = hotspot.clone();
				Model.A.scale.set(0.00035, 0.00025, 0.00025);
				Model.A.name = 'A';

				Model.B = hotspot.clone();
				Model.B.scale.set(0.00035, 0.00025, 0.00025);
				Model.B.name = 'B';

				Model.C = hotspot.clone();
				Model.C.scale.set(0.00035, 0.00025, 0.00025);
				Model.C.name = 'C';

				Model.D = hotspot.clone();
				Model.D.scale.set(0.00035, 0.00025, 0.00025);
				Model.D.name = 'D';

				Model.E = hotspot.clone();
				Model.E.scale.set(0.00035, 0.00025, 0.00025);
				Model.E.name = 'E';

			});
		};

		Model.texture = new THREE.TextureLoader().load( '/model/texture.png' );

		loader.load('/model/engine-transparent.fbx', ( group ) => {

			console.log(group);

			Model.engine = group.children[8].clone();
			Model.engine.name = 'engine';
			Model.engine.material[0].side = THREE.DoubleSide;
			Model.engine.material[1].side = THREE.DoubleSide;

			Model.F1 = group.children[0].clone();
			Model.F2 = group.children[1].clone();
			Model.F3 = group.children[2].clone();
			Model.F4 = group.children[3].clone();
			Model.F5 = group.children[4].clone();
			Model.F6 = group.children[5].clone();
			Model.F7 = group.children[6].clone();
			Model.F8 = group.children[7].clone();
			Model.F9 = group.children[9].clone();
		});
	}


	static startMetrology (callbackFn) {
		Model.createScene();

		Model.engine.material[0].transparent = true;
		Model.engine.material[0].opacity = 1;
		Model.engine.material[0].color = new THREE.Color('#f0f0f0');

		Model.engine.material[1].transparent = true;
		Model.engine.material[1].opacity = 1;
		Model.engine.material[1].color = new THREE.Color('#f0f0f0');

		Model.engine.position.y = 0;
		Model.scene.add(Model.engine);

		this.onClickCallback = callbackFn;

		document.getElementById('Model').appendChild( Model.renderer.domElement );
		Model.renderer.render(Model.scene, Model.camera);

		setTimeout(() => {

			zoom();

		}, 750);

		function zoom () {
			if (Model.engine) {
				if (Model.engine.material[0].opacity <= 0.33) {
					Model.animate();

					Model.scene.add(Model.A);
					Model.A.position.set(-30, 30, 40);
					

					Model.scene.add(Model.B);
					Model.B.position.set(-75, 60, -25);
					

					Model.scene.add(Model.C);
					Model.C.position.set(0, 70, 0);
					

					return;
				} else {
					Model.engine.material[0].opacity -= 0.025;
					Model.engine.material[1].opacity -= 0.025;

					let distance = 447.76 * Model.engine.material[0].opacity + 52.239;
					Model.camera.position.set(-distance, distance, distance);
				}
			}

			requestAnimationFrame(zoom);
			Model.renderer.render(Model.scene, Model.camera);
		}
	}

	static startInspection (callbackFn) {
		Model.createScene();

		Model.engine.material[0].transparent = true;
		Model.engine.material[0].opacity = 1;
		Model.engine.material[0].color = new THREE.Color('#f0f0f0');

		Model.engine.material[1].transparent = true;
		Model.engine.material[1].opacity = 1;
		Model.engine.material[1].color = new THREE.Color('#f0f0f0');

		Model.engine.position.y = 0;
		Model.scene.add(Model.engine);

		Model.F1.position.y = 60;
		//Model.F1.material[0].transparent = true;
		//Model.F1.material[0].opacity = 0.85;
		Model.F1.material[0].color = new THREE.Color('#0094FB');
		Model.F1.material[1].color = new THREE.Color('#16DD4B');
		Model.F1.material[2].color = new THREE.Color('#EFEE16');
		Model.F1.material[3].color = new THREE.Color('#F91616');

		Model.F2.position.y = 60;
		//Model.F2.material[0].transparent = true;
		//Model.F2.material[0].opacity = 0.85;
		Model.F2.material[0].color = new THREE.Color('#0094FB');
		Model.F2.material[1].color = new THREE.Color('#16DD4B');
		Model.F2.material[2].color = new THREE.Color('#EFEE16');
		Model.F2.material[3].color = new THREE.Color('#F91616');

		Model.F3.position.y = 60;
		//Model.F3.material[0].transparent = true;
		//Model.F3.material[0].opacity = 0.85;
		Model.F3.material[0].color = new THREE.Color('#0094FB');
		Model.F3.material[1].color = new THREE.Color('#16DD4B');
		Model.F3.material[2].color = new THREE.Color('#EFEE16');
		Model.F3.material[3].color = new THREE.Color('#F91616');

		Model.F4.position.y = 17.5;
		Model.F4.material.color = new THREE.Color('#D7C29B');

		Model.F5.position.y = 60;
		Model.F5.material = new THREE.MeshBasicMaterial();
		Model.F5.material.color = new THREE.Color('#929FA7');
		//Model.F5.material.transparent = true;
		//Model.F5.material.opacity = 0.50;

		Model.F6.position.y = 0;
		Model.F6.material = new THREE.MeshBasicMaterial( { map: Model.texture } );
		Model.F6.material.color = new THREE.Color('#fafafa');
		Model.F6.material.transparent = true;
		Model.F6.material.opacity = 0.33;

		Model.F7.position.y = 35;
		//Model.F7.material[0].transparent = true;
		//Model.F7.material[0].opacity = 0.85;
		Model.F7.material[0].color = new THREE.Color('#0094FB');
		Model.F7.material[1].color = new THREE.Color('#16DD4B');
		Model.F7.material[2].color = new THREE.Color('#EFEE16');
		Model.F7.material[3].color = new THREE.Color('#F91616');


		Model.F8.position.y = 35;
		//Model.F8.material[0].transparent = true;
		//Model.F8.material[0].opacity = 0.85;
		Model.F8.material[0].color = new THREE.Color('#0094FB');
		Model.F8.material[1].color = new THREE.Color('#16DD4B');
		Model.F8.material[2].color = new THREE.Color('#EFEE16');
		Model.F8.material[3].color = new THREE.Color('#F91616');

		Model.F9.position.y = 60;
		//Model.F9.material[0].transparent = true;
		//Model.F9.material[0].opacity = 0.85;
		Model.F9.material[0].color = new THREE.Color('#0094FB');
		Model.F9.material[1].color = new THREE.Color('#16DD4B');
		Model.F9.material[2].color = new THREE.Color('#EFEE16');
		Model.F9.material[3].color = new THREE.Color('#F91616');

		Model.F1.name = 'F';
		Model.F2.name = 'F';
		Model.F3.name = 'F';
		Model.F4.name = 'F';
		Model.F5.name = 'F';
		Model.F6.name = 'F';
		Model.F7.name = 'F';
		Model.F8.name = 'F';
		Model.F9.name = 'F';

		Model.scene.add(Model.F1);
		Model.scene.add(Model.F2);
		Model.scene.add(Model.F3);
		Model.scene.add(Model.F4);
		Model.scene.add(Model.F5);
		Model.scene.add(Model.F6);
		Model.scene.add(Model.F7);
		Model.scene.add(Model.F8);
		Model.scene.add(Model.F9);

		window.Model = Model;


		this.onClickCallback = callbackFn;

		document.getElementById('Model').appendChild( Model.renderer.domElement );
		Model.renderer.render(Model.scene, Model.camera);

		setTimeout(() => {

			zoom();

		}, 750);

		function zoom () {
			if (Model.engine) {
				if (Model.engine.material[0].opacity <= 0.33) {
					Model.animate();

					Model.scene.add(Model.A);
					Model.A.position.set(-25, 50, 30);
					

					Model.scene.add(Model.B);
					Model.B.position.set(-85, 25, -15);
					

					Model.scene.add(Model.C);
					Model.C.position.set(-55, 17.5, 37.5);
					

					Model.scene.add(Model.D);
					Model.D.position.set(50, -40, 45);
					

					Model.scene.add(Model.E);
					Model.E.position.set(-55, 65, 32.5);

					return;
				} else {
					Model.engine.material[0].opacity -= 0.025;
					Model.engine.material[1].opacity -= 0.025;

					let distance = 447.76 * Model.engine.material[0].opacity + 52.239;
					Model.camera.position.set(-distance, distance, distance);
				}
			}

			requestAnimationFrame(zoom);
			Model.renderer.render(Model.scene, Model.camera);
		}
	}

	static startAnalysis (callbackFn) {
		Model.createScene();

		Model.engine.material[0].transparent = true;
		Model.engine.material[0].opacity = 1;
		Model.engine.material[0].color = new THREE.Color('#f0f0f0');

		Model.engine.material[1].transparent = true;
		Model.engine.material[1].opacity = 1;
		Model.engine.material[1].color = new THREE.Color('#f0f0f0');

		Model.engine.position.y = 0;
		Model.scene.add(Model.engine);

		Model.F6.position.y = 0;
		Model.F6.material = new THREE.MeshBasicMaterial( { map: Model.texture } );
		Model.F6.material.transparent = true;
		Model.F6.material.opacity = 0.33;
		Model.F6.material.color = new THREE.Color('#fafafa');

		Model.F6.name = 'F';
		Model.scene.add(Model.F6);

		this.onClickCallback = callbackFn;

		document.getElementById('Model').appendChild( Model.renderer.domElement );
		Model.renderer.render(Model.scene, Model.camera);

		setTimeout(() => {

			zoom();

		}, 750);

		function zoom () {
			if (Model.engine) {
				if (Model.engine.material[0].opacity <= 0.33) {
					Model.animate();

					Model.scene.add(Model.A);
					Model.A.position.set(-25, 60, -15);
					

					Model.scene.add(Model.B);
					Model.B.position.set(-95, 55, -20);
					

					Model.scene.add(Model.C);
					Model.C.position.set(-25, 40, 30);
					

					Model.scene.add(Model.D);
					Model.D.position.set(30, 65, 30);
					

					return;
				} else {
					Model.engine.material[0].opacity -= 0.025;
					Model.engine.material[1].opacity -= 0.025;

					let distance = 447.76 * Model.engine.material[0].opacity + 52.239;
					Model.camera.position.set(-distance, distance, distance);
				}
			}

			requestAnimationFrame(zoom);
			Model.renderer.render(Model.scene, Model.camera);
		}
	}


	static animate () {
		if (Model.A) {
			Model.A.rotation.set(Model.camera.rotation.x, Model.camera.rotation.y, Model.camera.rotation.z);
		}

		if (Model.B) {
			Model.B.rotation.set(Model.camera.rotation.x, Model.camera.rotation.y, Model.camera.rotation.z);
		}

		if (Model.C) {
			Model.C.rotation.set(Model.camera.rotation.x, Model.camera.rotation.y, Model.camera.rotation.z);
		}

		if (Model.D) {
			Model.D.rotation.set(Model.camera.rotation.x, Model.camera.rotation.y, Model.camera.rotation.z);
		}

		if (Model.E) {
			Model.E.rotation.set(Model.camera.rotation.x, Model.camera.rotation.y, Model.camera.rotation.z);
		}

		requestAnimationFrame(Model.animate);
		Model.renderer.render(Model.scene, Model.camera);
	}




	static setOnFinishedLoading (func) {
		this.cbfunc = func;
	}

	static finishedLoading() {
		this.cbfunc();
	}

}